import { invalidateProjectProgress } from "~/repository/projectUtils";
import {
  ADD_TASK_SUCCESS,
  COMPLETE_TASK_SUCCESS,
  OPEN_TASK_SUCCESS,
  MOVE_TASK_TO_TRASH_SUCCESS,
  RESTORE_TASK_FROM_TRASH_SUCCESS,
  DUPLICATE_TASK_SUCCESS,
  MOVE_TASK_TO_PROJECT_SUCCESS,
  ADD_TASK_FROM_RECURRING_TASK_SUCCESS,
  MOVE_TASK_LIST_TO_TRASH_SUCCESS,
  COMPLETE_TASK_LIST_SUCCESS,
  DUPLICATE_TASK_LIST_SUCCESS,
  MOVE_TASK_LIST_TO_PROJECT_SUCCESS,
  BATCH_EDIT_TASKS_SUCCESS,
  BATCH_EDIT_EXPENSES_SUCCESS,
  BATCH_EDIT_TIME_RECORDS_SUCCESS,
  ADD_TIME_RECORD_SUCCESS,
  DELETE_TIME_RECORD_SUCCESS,
  ADD_EXPENSE_SUCCESS,
  MOVE_EXPENSE_TO_TRASH_SUCCESS,
  CONVERT_DISCUSSION_TO_TASK_SUCCESS,
  MOVE_EXPENSE_SUCCESS,
  MOVE_TIME_RECORD_SUCCESS,
  ADD_TASK_FROM_CONVERSATION_SUCCESS,
  EDIT_PROJECT_SUCCESS,
  COMPLETE_PROJECT_SUCCESS,
  OPEN_PROJECT_SUCCESS,
  EDIT_TASK_SUCCESS,
  EDIT_EXPENSE_SUCCESS,
  EDIT_TIME_RECORD_SUCCESS,
  CREATE_TASK_FROM_COMMENT_SUCCESS,
} from "~/store/action_types/index.jsx";

const projectProgressMiddleware = () => (next) => (action) => {
  const { type } = action;
  switch (type) {
    case RESTORE_TASK_FROM_TRASH_SUCCESS:
    case MOVE_TASK_TO_TRASH_SUCCESS:
    case OPEN_TASK_SUCCESS:
    case COMPLETE_TASK_SUCCESS:
    case COMPLETE_TASK_LIST_SUCCESS:
    case MOVE_TASK_LIST_TO_TRASH_SUCCESS:
    case ADD_TIME_RECORD_SUCCESS:
    case DELETE_TIME_RECORD_SUCCESS:
    case ADD_EXPENSE_SUCCESS:
    case EDIT_EXPENSE_SUCCESS:
    case EDIT_TIME_RECORD_SUCCESS:
    case CREATE_TASK_FROM_COMMENT_SUCCESS:
    case MOVE_EXPENSE_TO_TRASH_SUCCESS: {
      const { response } = action;
      const { single } = response;
      invalidateProjectProgress(single.project_id);

      return next(action);
    }
    case ADD_TASK_FROM_CONVERSATION_SUCCESS: {
      const { attributes } = action;
      invalidateProjectProgress(attributes.project_id);

      return next(action);
    }
    case EDIT_PROJECT_SUCCESS: {
      const { project_id } = action;
      invalidateProjectProgress(project_id);

      return next(action);
    }
    case COMPLETE_PROJECT_SUCCESS:
    case OPEN_PROJECT_SUCCESS: {
      const { id } = action;
      invalidateProjectProgress(id);

      return next(action);
    }
    case ADD_TASK_SUCCESS:
    case ADD_TASK_FROM_RECURRING_TASK_SUCCESS:
    case EDIT_TASK_SUCCESS:
    case DUPLICATE_TASK_SUCCESS:
    case DUPLICATE_TASK_LIST_SUCCESS:
    case CONVERT_DISCUSSION_TO_TASK_SUCCESS:
    case MOVE_TIME_RECORD_SUCCESS:
    case MOVE_EXPENSE_SUCCESS: {
      const { projectId } = action;
      invalidateProjectProgress(projectId);

      return next(action);
    }
    case MOVE_TASK_LIST_TO_PROJECT_SUCCESS:
    case MOVE_TASK_TO_PROJECT_SUCCESS: {
      const { projectId, newProjectId, copy } = action;
      if (!copy) {
        invalidateProjectProgress(projectId);
      }
      invalidateProjectProgress(newProjectId);
      return next(action);
    }
    case BATCH_EDIT_TASKS_SUCCESS: {
      const { projectId, attributes } = action;
      if (attributes?.move_all || attributes?.trash_all || attributes?.complete_all) {
        invalidateProjectProgress(projectId);
      }
      return next(action);
    }
    case BATCH_EDIT_TIME_RECORDS_SUCCESS:
    case BATCH_EDIT_EXPENSES_SUCCESS: {
      const { projectId } = action;
      if (action?.move_all || action?.trash_all) {
        invalidateProjectProgress(projectId);
      }
      return next(action);
    }
    default:
      return next(action);
  }
};

export default projectProgressMiddleware;
